import { lazy, Suspense } from 'react';

/**
 * Carga ReloadPrompt solo en produccion.
 * En dev, el plugin vite-plugin-pwa no esta activo y el modulo
 * virtual:pwa-register/react no existe, asi que no podemos importarlo.
 */
const ReloadPromptLazy = import.meta.env.PROD
  ? lazy(() => import('./ReloadPrompt').then((m) => ({ default: m.ReloadPrompt })))
  : () => null;

export function ReloadPromptLoader() {
  if (!import.meta.env.PROD) return null;

  return (
    <Suspense fallback={null}>
      <ReloadPromptLazy />
    </Suspense>
  );
}
